export var IFrameActionType;
(function (IFrameActionType) {
    IFrameActionType["StartRecording"] = "startRecording";
    IFrameActionType["StopRecording"] = "stopRecording";
    IFrameActionType["Unload"] = "unload";
    IFrameActionType["Load"] = "load";
})(IFrameActionType || (IFrameActionType = {}));
